export const SALES_PORTAL_LOGIN_URL = '/sales-portal/beesafe/login';
